/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReceiveAddressVo } from './ReceiveAddressVo';
import {
    ReceiveAddressVoFromJSON,
    ReceiveAddressVoFromJSONTyped,
    ReceiveAddressVoToJSON,
    ReceiveAddressVoToJSONTyped,
} from './ReceiveAddressVo';

/**
 * 
 * @export
 * @interface ResponseReceiveAddressVo
 */
export interface ResponseReceiveAddressVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseReceiveAddressVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseReceiveAddressVo
     */
    message?: string;
    /**
     * 
     * @type {ReceiveAddressVo}
     * @memberof ResponseReceiveAddressVo
     */
    data?: ReceiveAddressVo;
}

/**
 * Check if a given object implements the ResponseReceiveAddressVo interface.
 */
export function instanceOfResponseReceiveAddressVo(value: object): value is ResponseReceiveAddressVo {
    return true;
}

export function ResponseReceiveAddressVoFromJSON(json: any): ResponseReceiveAddressVo {
    return ResponseReceiveAddressVoFromJSONTyped(json, false);
}

export function ResponseReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ReceiveAddressVoFromJSON(json['data']),
    };
}

export function ResponseReceiveAddressVoToJSON(json: any): ResponseReceiveAddressVo {
    return ResponseReceiveAddressVoToJSONTyped(json, false);
}

export function ResponseReceiveAddressVoToJSONTyped(value?: ResponseReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ReceiveAddressVoToJSON(value['data']),
    };
}

